/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { IConsultationBox } from "@/api/AppApi/services/home/interfaces/IConsultationBox";
import { useProductHasAttrs } from "@/hooks/product-has-attrs/useProductHasAttrs";
import { useIsMobile } from "@/hooks/useIsMobile";
import ConsultationForm from "./consult-form/ConsultationForm";
import Separator from "../../lib/Separator";
import Attributes from "../../pages-components/product-details-page/details-belpers/product-attributes/Attributes";
import AddOns from "../../pages-components/product-details-page/details-belpers/product-addons/AddOns";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";

interface Props extends IConsultationBox {}

const ConsultationBox: React.FC<Props> = (props) => {
  const company = useGetCompanyQuery();
  const { auto_select_first_child_in_show_product: autoSelectFirstChild } =
    company?.data?.result?.theme?.components?.product ?? {};
  const product = props.data;
  const productState = useProductHasAttrs(product);
  const { currentProd } = productState;
  const mobile = useIsMobile();
  const mClass = mobile ? "-mobile" : "";

  return (
    <>
      {mobile && <Separator startLabel={props.configurations.title} />}
      <div
        className={`consutation${mClass}`}
        style={
          mobile
            ? {}
            : {
                backgroundSize: "cover",
                backgroundImage: `url('${props.configurations.background_image}')`,
                backgroundRepeat: "no-repeat, no-repeat",
                backgroundPosition: "center center",
              }
        }
      >
        <div className="consult-details">
          {!mobile && (
            <div className="consult-header">{props.configurations.title}</div>
          )}
          <div className="consult-section">
            {product?.attributes_builder?.length > 0 && (
              <Attributes
                product={product}
                setSelectedChildIndex={productState.setSelectedChildIndex}
                autoSelectFirstChild={autoSelectFirstChild!}
              />
            )}
            {currentProd?.addons_builder?.length > 0 && (
              <AddOns
                addOnBiulder={currentProd.addons_builder}
                state={productState.selectedAddOns}
                setState={productState.handleSelectedAddOnsChanged}
              />
            )}

            {!!currentProd.description ||
              (!!product.description && (
                <div className="consult-section-body">
                  {currentProd.description ?? product.description}
                </div>
              ))}
          </div>
          <ConsultationForm productState={productState} product={product} />
        </div>
      </div>
    </>
  );
};

export default ConsultationBox;
